import type { InputNumberProps } from 'antd';
import { Form, Radio } from 'antd';
import type { NamePath, StoreValue } from 'rc-field-form/es/interface';
import { useContext } from 'react';

import { ApplicationFeesTooltip } from 'app/components/commons/Room/Beds/_components/ApplicationFeesTooltip';
import { SelectBedByPriority } from 'app/components/commons/Room/Beds/_components/SelectBedByPriority';
import { RULES } from 'app/components/pages/Hotels/HotelDetail/Finance/utils';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import type { BedCategory } from 'app/typings';

import { FormLineLayout } from '../../../FormLineLayout/FormLineLayout';

type BedTypeRowProps = {
  bedCategories: BedCategory[];
  index: number;
  getFieldValue: (name: NamePath) => StoreValue;
  name: string[];
  restField: { fieldKey?: number | undefined };
};

export const BedTypeRow = ({
  bedCategories,
  index,
  getFieldValue,
  name,
  restField,
}: BedTypeRowProps) => (
  <div className="input-row bed-config__type">
    <SelectBedByPriority
      bedCategories={bedCategories}
      index={index}
      getFieldValue={getFieldValue}
      name={name}
      label="Type"
      rules={RULES}
      {...restField}
      hideTitle={true}
    />
  </div>
);

type BedCostRowProps = {
  restField: {
    fieldKey?: number | undefined;
  };
  name: number[];
};

export const BedCostRow = ({ restField, name }: BedCostRowProps) => {
  const { isViewMode } = useContext(ViewEditModeContext);

  return (
    <div className="input-row included bed-config__cost">
      <FormLineLayout label="Cost of bed" isRequired={true}>
        <Form.Item {...restField} name={[...name, 'included']} noStyle>
          <Radio.Group disabled={isViewMode} className="bed-config__cost__form">
            <Radio value={true}>Free of charge</Radio>
            <Radio value={false}>
              Applicable fees <ApplicationFeesTooltip />
            </Radio>
          </Radio.Group>
        </Form.Item>
      </FormLineLayout>
    </div>
  );
};

type BedPriceRowProps = {
  restField: {
    fieldKey?: number | undefined;
  };
  name: number[];
  currencyInput: (props: InputNumberProps) => JSX.Element;
};

export const BedPriceRow = ({
  restField,
  name,
  currencyInput,
}: BedPriceRowProps) => (
  <div className="input-row bed-config__price">
    <FormLineLayout label="Fees amount" isRequired={true}>
      <Form.Item {...restField} name={[...name, 'price']} rules={RULES}>
        {currencyInput({ min: 0 })}
      </Form.Item>
    </FormLineLayout>
  </div>
);
